import React, { FunctionComponent } from 'react';
import { View } from 'react-native';
import { Svg, Path } from 'react-native-svg';

import { Color } from '~/components/color';

import { IconProps } from './icon-types';

export const ChevronRightIcon: FunctionComponent<IconProps> = ({ fill, size = 24 }) => {
    return (
        <View style={{ width: size, height: size }}>
            {/* @ts-ignore see https://github.com/react-native-svg/react-native-svg/issues/1471 */}
            <Svg accessible={false} viewBox="0 0 24 24" focusable={false} tabIndex="-1">
                <Path
                    d="M10 6L16 12L10 18"
                    strokeLinecap="round"
                    stroke={fill ?? Color.ALMOST_BLACK}
                    fill={Color.TRANSPARENT}
                    strokeWidth="2"
                    // @ts-ignore
                    tabIndex="-1"
                />
            </Svg>
        </View>
    );
};
